<template>
  <div class="page-deliver-todo">
    <div class="pg-breadcrumb">
      <div class="breadcrumb-item em">集金幣管理</div>
      <div class="breadcrumb-item">集金幣日誌</div>
    </div>
    <div class="card-block">
      <Form inline class="pg-form-inline">
        <FormItem>
          <Select
            size="small"
            placeholder="操作類型"
            v-model="form.type"
            clearable
          >
            <!-- <Option :value="item.id" v-for="(item, index) in pickAddress"
                          :key="item.id">{{item.name}}
                  </Option> -->

            <Option :value="1">用戶充值</Option>
            <Option :value="2">用戶消費</Option>
            <Option :value="3">下家消費</Option>
            <Option :value="5">集金幣消費</Option>
            <Option :value="7">獲得集金幣</Option>
            <Option :value="9">優惠贈送</Option>
          </Select>
        </FormItem>
        <FormItem>
          <Select
            size="small"
            placeholder="提貨櫃點"
            v-model="form.store_id"
            clearable
          >
            <Option
              :value="item.ReceivingID"
              v-for="(item, index) in pickAdmin"
              :key="item.ReceivingID"
              >({{ item.cainiao_match }}) {{ item.ReceivingName }}
            </Option>
          </Select>
        </FormItem>
        <FormItem>
          <DatePicker
            class="no-suffix"
            type="datetime"
            size="small"
            :clearable="false"
            placeholder="日誌開始日期"
            v-model="form.start_time"
            value-format="yyyy-MM-dd hh:mm:ss"
            :editable="false"
            style="width: 100%"
          ></DatePicker>
        </FormItem>
        <FormItem>-</FormItem>
        <FormItem>
          <DatePicker
            class="no-suffix"
            type="datetime"
            size="small"
            :clearable="false"
            placeholder="日誌結束日期"
            v-model="form.end_time"
            value-format="yyyy-MM-dd hh:mm:ss"
            :editable="false"
            style="width: 100%"
          ></DatePicker>
        </FormItem>
      </Form>
      <Form inline class="pg-form-inline form-input-wrap">
        <FormItem>
          <label class="input-label">快遞單號</label>
          <Input
            size="small"
            v-model="form.odd_number"
            @keyup.enter.native="handleSearch()"
            clearable
          ></Input>
        </FormItem>
        <FormItem>
          <label class="input-label">手機號碼</label>
          <Input
            size="small"
            v-model="form.phone"
            @keyup.enter.native="handleSearch()"
            clearable
          ></Input>
        </FormItem>
        <FormItem>
          <div class="pg-btn-wrap">
            <div class="pg-btn style1" @click="handleSearch">搜索</div>
            <div class="pg-btn style2" @click="handleExport">導出excel</div>
          </div>
        </FormItem>
      </Form>
    </div>

    <div class="card-block pd-bt">
      <Spin fix class="pg-sub-loading" v-if="isSubmiting">
        <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
        <div class="loading-text">Loading</div>
      </Spin>

      <Table
        size="small"
        border
        no-data-text="暫無數據"
        :columns="table.column"
        :data="table.data"
      >
      </Table>

      <div class="pg-pagger">
        <Row>
          <Col span="11" class="pagger-left">
            <div class="pagger-total">總共{{ totalCount }}條記錄</div>
          </Col>
          <Col span="13" class="pagger-right">
            <!-- v-if="totalCount > curPageSize" -->
            <div>
              <div class="pagger-sizer">
                <span>每頁</span>
                <Select
                  v-model="curPageSize"
                  size="small"
                  placeholder="數量"
                  @on-change="handlePageSizeChange"
                >
                  <Option :value="10">10</Option>
                  <Option :value="20">20</Option>
                  <Option :value="30">30</Option>
                  <Option :value="40">40</Option>
                  <Option :value="50">50</Option>
                </Select>
              </div>

              <div class="pagger-elevator">
                <span>跳轉</span>
                <Input
                  size="small"
                  v-model="pageInput"
                  @on-keyup="handlePageInput"
                  @on-enter="handlePageEnter"
                />
              </div>

              <Page
                size="small"
                :current="pageIndex"
                :page-size="curPageSize"
                :total="totalCount"
                @on-change="handlePageChange"
              >
              </Page>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      pageIndex: 1, //页码
      curPageSize: 10, //一页数量
      totalCount: 1, //总条数
      pageInput: "", //输入的页码
      pickAddress: [], //提貨櫃點
      packageType: [], //包裹類型
      pickAdmin: [],
      form: {
        type: "",
        store_id: "",
        odd_number: "",
        phone: "",
        start_time: "",
        end_time: "",
      },
      isSubmiting: false,
      exportLink: "",
      table: {
        column: [
          {
            title: "操作時間",
            key: "updated_at",
            align: "center",
            sortable: true,
            minWidth: 150,
          },
          {
            title: "客戶名稱",
            key: "username",
            align: "center",
            sortable: true,
            minWidth: 130,
          },
          {
            title: "聯絡電話",
            key: "phone",
            align: "center",
            sortable: true,
            minWidth: 130,
          },
          {
            title: "單號",
            key: "odd_number",
            align: "center",
            sortable: true,
            minWidth: 160,
          },
          {
            title: "操作類型",
            key: "type",
            align: "center",
            sortable: true,
            minWidth: 100,
          },
          {
            title: "操作門店",
            key: "store_id",
            align: "center",
            sortable: true,
            minWidth: 100,
          },
          {
            title: "下家",
            key: "subordinate_id",
            align: "center",
            sortable: true,
            minWidth: 120,
          },
          {
            title: "下家操作類型",
            key: "subordinate_type",
            align: "center",
            sortable: true,
            minWidth: 100,
          },
          {
            title: "現有集金幣",
            key: "jpoint_new",
            align: "center",
            sortable: true,
            minWidth: 100,
          },
          {
            title: "集金幣變動",
            key: "jpoint_change",
            align: "center",
            sortable: true,
            minWidth: 100,
          },
          {
            title: "集金幣結餘",
            key: "jpoint_balance",
            align: "center",
            sortable: true,
            minWidth: 100,
          },
          {
            title: "上家獲得集金幣",
            key: "Jpoint_superior",
            align: "center",
            sortable: true,
            minWidth: 100,
          },
          {
            title: "描述",
            key: "describe",
            align: "center",
            sortable: true,
            minWidth: 100,
          },
        ],
        data: [],
      },
    };
  },
  created() {
    this.getPickAddress();
    this.getList();
  },
  methods: {
    getPickAddress() {
      this.$Rq
        .requestAuth({
          url: this.$Api.pickAddress,
          method: "get",
          data: {
            company_id: 0,
          },
        })
        .then((res) => {
          if (res.code == 0) {
            this.pickAdmin = res.data.data.filter((it) => it.company_id != 15);
          }
        });
    },
    getJointType() {
      this.$Rq
        .requestAuth({
          url: this.$Api.jpointroleType,
          method: "get",
        })
        .then((res) => {
          if (res.code == 0) {
            this.pickAddress = res.data.data;
          }
        });
    },
    formatDate(datetime) {
      if (!datetime) return "";

      let dateTime = new Date(datetime);
      let year = dateTime.getFullYear();
      let month = dateTime.getMonth() + 1;
      let date = dateTime.getDate();
      let hour = dateTime.getHours();
      let minute = dateTime.getMinutes();
      let second = dateTime.getSeconds();
      let milliseconds = dateTime.getMilliseconds();
      return `${this.formatNum(year)}-${this.formatNum(month)}-${this.formatNum(
        date
      )} ${this.formatNum(hour)}:${this.formatNum(second)}:${this.formatNum(
        milliseconds
      )}`;
    },
    formatNum(num) {
      return num < 10 ? "0" + num : num;
    },
    getList() {
      let form = this.form;
      this.isSubmiting = true;
      this.$Rq
        .requestAuth({
          url: this.$Api.jpointlogsList,
          method: "get",
          data: {
            offset: (this.pageIndex - 1) * this.curPageSize,
            limit: this.curPageSize,
            type: form.type,
            store_id: form.store_id,
            odd_number: form.odd_number,
            phone: form.phone,
            start_time: this.formatDate(form.start_time),
            end_time: this.formatDate(form.end_time),
          },
        })
        .then((res) => {
          this.isSubmiting = false;
          if (res.code == 1) {
            let tempArr = [];
            let resData = res.data.data;
            let jpoint_change;

            for (let i = 0; i < resData.length; i++) {
              if (resData[i].type == 1) {
                resData[i].type = "用戶充值";
                jpoint_change = "+" + resData[i].jpoint_change;
              }
              if (resData[i].type == 2) {
                resData[i].type = "用戶消費";
                jpoint_change = "+" + resData[i].jpoint_change;
              }
              if (resData[i].type == 3) {
                resData[i].type = "下家消費";
                jpoint_change = "+" + resData[i].jpoint_change;
              }
              if (resData[i].type == 5) {
                resData[i].type = "集金幣消費";
                jpoint_change = "-" + resData[i].jpoint_change;
              }
              if (resData[i].type == 7) {
                resData[i].type = "集金幣贈送";
                jpoint_change = "+" + resData[i].jpoint_change;
              }
              if (resData[i].type == 9) {
                resData[i].type = "優惠贈送";
                jpoint_change = "+" + resData[i].jpoint_change;
              }

              tempArr.push({
                id: resData[i].id,
                order_flow: resData[i].order_flow,
                describe: resData[i].describe,
                odd_number: resData[i].odd_number,
                jpoint_new: resData[i].jpoint_new,
                jpoint_balance: resData[i].jpoint_balance,
                jpoint_change: jpoint_change,
                subordinate_type:
                  resData[i].subordinate_type == null
                    ? "無"
                    : resData[i].subordinate_type,
                subordinate_id:
                  resData[i].subordinate_id == null
                    ? "無"
                    : resData[i].subordinate_id,
                username:
                  resData[i].users == null ? "無" : resData[i].users.user_name,
                phone: resData[i].users == null ? "無" : resData[i].users.phone,
                updated_at: resData[i].updated_at,
                type: resData[i].type,
                store_id:
                  resData[i].receliving == null
                    ? "- - -"
                    : resData[i].receliving.ReceivingName,
                Jpoint_superior:
                  resData[i].Jpoint_superior == null
                    ? "- - -"
                    : resData[i].Jpoint_superior,
              });
            }

            this.totalCount = res.data.count;
            this.table.data = tempArr;
          }
        })
        .catch((err) => {
          this.isSubmiting = false;
        });
    },
    handleSearch() {
      this.pageIndex = 1;
      this.getList();
    },
    handleEdit(index) {
      let tableData = this.table.data;
      this.$router.push({ path: "/deliverTodoEdit?id=" + tableData[index].id });
    },
    handleExport() {
      let form = this.form;
      if (form.type === "") {
        this.$Utils.showTipInfo("請輸入操作類型");
        return;
      }
      if (form.start_time == "") {
        this.$Utils.showTipInfo("請選擇日誌開始時間");
      } else if (form.end_time == "") {
        this.$Utils.showTipInfo("請選擇日誌结束時間");
      }
      let token = localStorage.getItem("jyb_token");
      let params = {
        Authorization: token,
        store_id: form.store_id,
        type: form.type,
        phone: form.phone,
        odd_number: form.odd_number,
        start_time: this.formatDate(form.start_time),
        end_time: this.formatDate(form.end_time),
      };
      let formatParams = this.$Utils.formateObjToParamStr(params);
      window.open(`${this.$Api.jpointlogExcel}?${formatParams}`, "_blank");
    },
    handlePageSizeChange(value) {
      this.pageIndex = 1;
      this.getList();
    },
    handlePageInput() {
      let value = ("" + this.pageInput).replace(/\D/g, "");
      let pageCount = Math.ceil(this.totalCount / this.curPageSize);
      if (value > pageCount) {
        value = pageCount;
      }
      this.pageInput = value;
    },
    handlePageEnter() {
      if (this.pageInput == "" || this.pageInput == this.pageIndex) return;
      if (this.pageInput == 0) {
        this.pageInput = 1;
      }
      this.pageInput = parseInt(this.pageInput);
      this.pageIndex = this.pageInput;
      this.getList();
    },
    handlePageChange(value) {
      this.pageIndex = value;
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "jpointLog.scss";
</style>
